export default {
  store:[],
  publishers:[],
  publisher: 'All Publishers',
  readingBook: {} ,
  sample : false,
  bookMappings: {},
  bookMoves: {},
  chapterContent: undefined,
  chapter: undefined,
  toc: ''
}
